<template>
  <div>
    <description-card
      :reverse="false"
      headline="components.thg.ThgProcessDescriptionCard.car.headline"
      description="components.thg.ThgProcessDescriptionCard.car.text"
    >
      <thg-description-svg-car width="350" height="300" viewBox="0 0 1100 800" />
    </description-card>

    <description-card
      :reverse="true"
      headline="components.thg.ThgProcessDescriptionCard.registration.headline"
      description="components.thg.ThgProcessDescriptionCard.registration.text"
    >
      <thg-description-svg-registration width="380" height="300" viewBox="500 0 4400 2600" />
    </description-card>

    <description-card
      :reverse="false"
      headline="components.thg.ThgProcessDescriptionCard.agency.headline"
      description="components.thg.ThgProcessDescriptionCard.agency.text"
    >
      <thg-description-svg-agency width="350" height="300" viewBox="0 0 700 700" />
    </description-card>

    <description-card
      :reverse="true"
      headline="components.thg.ThgProcessDescriptionCard.quote.headline"
      description="components.thg.ThgProcessDescriptionCard.quote.text"
    >
      <thg-description-svg-quote width="350" height="300" viewBox="0 0 700 800" />
    </description-card>

    <description-card
      :reverse="false"
      headline="components.thg.ThgProcessDescriptionCard.sustainability.headline"
      description="components.thg.ThgProcessDescriptionCard.sustainability.text"
    >
      <thg-description-svg-sustainability width="350" height="300" viewBox="0 0 1100 800" />
    </description-card>

    <description-card
      :reverse="true"
      headline="components.thg.ThgProcessDescriptionCard.yearly.headline"
      description="components.thg.ThgProcessDescriptionCard.yearly.text"
    >
      <thg-description-svg-yearly width="350" height="300" viewBox="0 0 800 800" />
    </description-card>
  </div>
</template>

<style scoped></style>

<script lang="ts">
import CreateOrUpdateBankDialog from "@/components/profile/CreateOrUpdateBankDialog.vue";
import ThgDescriptionSvgCar from "@/components/thg/ThgDescriptionSvgCar.vue";
import ThgDescriptionSvgAgency from "@/components/thg/ThgDescriptionSvgAgency.vue";
import ThgDescriptionSvgRegistration from "@/components/thg/ThgDescriptionSvgRegistration.vue";
import ThgDescriptionSvgSustainability from "@/components/thg/ThgDescriptionSvgSustainability.vue";
import ThgDescriptionSvgQuote from "@/components/thg/ThgDescriptionSvgQuote.vue";
import ThgDescriptionSvgYearly from "@/components/thg/ThgDescriptionSvgYearly.vue";
import DescriptionCard from "@/components/thg/DescriptionCard.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    CreateOrUpdateBankDialog,
    ThgDescriptionSvgRegistration,
    ThgDescriptionSvgCar,
    DescriptionCard,
    ThgDescriptionSvgAgency,
    ThgDescriptionSvgQuote,
    ThgDescriptionSvgSustainability,
    ThgDescriptionSvgYearly
  }
})
export default class ThgProcessDescriptionCard extends Vue {}
</script>
